import React, { useEffect, useState } from "react";
import Container from "../../../components/Container";
import { BtnPadrao, BtnDeletar, BtnEdit, ModalPadrao, LabelPadrao, InputPadrao, CheckBoxPadrao, LoadingContainerPadrao, BtnIncluir } from "../../../components/Base";
import { Divider, Tooltip } from "antd";
import TabelaPadrao from "../../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch, useSave } from "../../../components/Hooks/Conexao";
import BusinessIcon from "@material-ui/icons/Business";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Mensagens from "../../../components/Mensagens";
import { Radio } from "antd";
import InputEmail from "../../../components/InputEmail";
import ListCheckBox from "../../../components/ListCheckBox";
import { connect } from "react-redux";
import { logIn, fetch } from "../../../actions/index";
const MODELO = "usuarios";

function Usuarios(props) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [detalhe, setDetalhe] = useState(null);

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
    },
    {
      Header: "Email",
      accessor: "email",
    },

    {
      Header: "Modelo",
      accessor: "modelo",
      Cell: data => {
        const row = data.row.original.modelo;
        return (
          <div>
            <Tooltip title="Loja">
              <BusinessIcon style={{ color: row === "loja" ? "#4791db" : "#ddd" }} />
            </Tooltip>
            <Tooltip title="Fabricante">
              <LocalShippingIcon style={{ color: row === "fabricante" ? "#4791db" : "#ddd", margin: "0 5px" }} />
            </Tooltip>
            {/* <Tooltip title="Setor">
              <PieChartIcon style={{ color: row === "set" ? "#4791db" : "#ddd" }} />
            </Tooltip> */}
          </div>
        );
      },
    },
    {
      Header: " ",
      accessor: "idUsuario",
      tipo: "right",
      Cell: data => {
        const row = data.row.original.idUsuario;
        return (
          <div>
            <BtnEdit style={{ marginRight: 10 }} onClick={() => setDetalhe(row)} />
            <BtnDeletar
              onOk={() =>
                listarDados(
                  () => api.deletar(props.fetch, row),
                  () => {
                    const aux = [...dados];
                    aux.splice(
                      dados.findIndex(x => x.idUsuario === row),
                      1
                    );
                    setDados(aux);
                    Mensagens.showSucesso("Usuário deletado com sucesso!");
                  }
                )
              }
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    listarDados(() => api.getAll(props.fetch));
  }, []);

  function onOk(v) {
    const aux = [...dados];

    const regInx = aux.findIndex(x => x.idUsuario === v.idUsuario);

    if (aux.findIndex(x => x.idUsuario === v.idUsuario) !== -1) {
      aux[regInx] = v;
    } else {
      aux.push(v);
    }
    setDados(aux);
    setDetalhe(null);
  }

  return (
    <>
      <Container loading={loading}>
        <div>
          <Divider orientation="left">Usuário</Divider>
          <BtnIncluir type="primary" onClick={() => setDetalhe(-1)} ghost />
        </div>
        <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />
        {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
      </Container>
      <ModalInserir fetch={props.fetch} id={detalhe} onCancel={() => setDetalhe(null)} onOk={onOk} />
    </>
  );
}
export default connect(null, { logIn, fetch })(Usuarios);

function ModalInserir({ id, onOk, onCancel, fetch, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [gravar, setGravar] = useState();

  useEffect(() => {
    if (dados) {
      if ((dados.lojasSelecionadas || []).length) {
        setGravar(false);
        return;
      } else if ((dados.gruposSelecionados || []).length) {
        setGravar(false);
        return;
      } else if ((dados.setoresSelecionados || []).length) {
        setGravar(false);
        return;
      } else if ((dados.fabricantesSelecionados || []).length) {
        setGravar(false);
        return;
      } else {
        setGravar(true);
      }
    }
  }, [dados]);
  const [save, saving] = useSave(
    () => api.post(fetch, dados),
    v => {
      Mensagens.showSucesso("Dados salvos com sucesso!");
      if (v) onOk({ ...dados, idUsuario: v });
      else onOk(dados);

    }
  );

  function onSave() {
    if (!dados.nome || !dados.senha) {
      Mensagens.showErro("Dados não preenchidos!");
      return;
    }
    save();
  }

  useEffect(() => {
    if (id) listarDados(() => api.getDetalhe(fetch, id));
  }, [id]);

  useEffect(() => {
    if (dados) {
      if (!dados.lojasSelecionadas) setDados({ ...dados, lojasSelecionadas: [] });
      if (!dados.gruposSelecionados) setDados({ ...dados, gruposSelecionados: [] });
      if (!dados.fabricantesSelecionados) setDados({ ...dados, fabricantesSelecionados: [] });
      if (!dados.setoresSelecionados) setDados({ ...dados, setoresSelecionados: [] });
    }
  }, [dados]);

  function checkedList(nome, v, x, onlyOne) {
    let list = [...dados[nome]];

    if (!v.target.checked) {
      if (onlyOne && list.length === 1) {
        return;
      }

      list.splice(
        list.findIndex(i => i === x),
        1
      );
    } else {
      if (!list) list = [];

      if (onlyOne) {
        list = [x];
        console.log("new list", list);
      } else {
        list.push(x);
      }
    }
    setDados({ ...dados, [nome]: list });
  }

  return (
    <ModalPadrao
      visible={id}
      onCancel={onCancel}
      title="Usuário"
      width={1200}
      footer={
        <>
          <BtnPadrao type="primary" onClick={onSave} loading={saving} disabled={gravar}>
            Gravar
          </BtnPadrao>
          <BtnPadrao type="primary" onClick={onCancel} ghost>
            Sair
          </BtnPadrao>
        </>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        <div>
          <LabelPadrao noMargin>Nome</LabelPadrao>
          <InputPadrao value={(dados || []).nome} onChange={v => setDados({ ...dados, nome: v.target.value })} autoFocus />
        </div>
        <div>
          <LabelPadrao>Email</LabelPadrao>
          <InputEmail value={(dados || []).email} setValue={v => setDados({ ...dados, email: v })} />
        </div>
        <div>
          <LabelPadrao>Senha</LabelPadrao>
          <InputPadrao value={(dados || []).senha} onChange={v => setDados({ ...dados, senha: v.target.value })} type="password" />
        </div>
        <div>
          <LabelPadrao>Email Destinatário dos Pedidos</LabelPadrao>
          <InputPadrao value={(dados || []).emailPedidos} onChange={v => setDados({ ...dados, emailPedidos: v.target.value })} />
        </div>
        <div style={{ background: "#f7f7f7", borderRadius: 10, marginTop: 20, display: "flex", flexDirection: "column", alignItems: "center", padding: 10 }}>
          <p style={{ fontWeight: "bold", textAlign: "center" }}>Modelo</p>
          <Radio.Group value={(dados || []).modelo} onChange={v => setDados({ ...dados, modelo: v.target.value })}>
            <Radio value="loja">Loja</Radio>
            <Radio value="fabricante">Fabricante</Radio>
          </Radio.Group>
        </div>
        {/* {!!dados && <pre>{JSON.stringify(dados.lojasSelecionadas)}</pre>} */}
        {dados && (
          <>
            {dados.modelo === "loja" && (
              <ListCheckBox title="Lojas" modelo="empresa" selecionado={dados.lojasSelecionadas} onChange={(v, x) => checkedList("lojasSelecionadas", v, x)} />
            )}
            {dados.modelo === "fabricante" && (
              <div className="flex-gap">
                <ListCheckBox title="Lojas" modelo="empresa" selecionado={dados.lojasSelecionadas} onChange={(v, x) => checkedList("lojasSelecionadas", v, x)} />
                <ListCheckBox title="Setores" modelo="setor" selecionado={dados.setoresSelecionados} onChange={(v, x) => checkedList("setoresSelecionados", v, x)} />

                {/* <ListCheckBox title="Fabricantes" modelo="fabricante" selecionado={dados.fabricantesSelecionados} onChange={(v, x) => checkedList("fabricantesSelecionados", v, x, true)} /> */}
                <ListCheckBox title="Fabricantes" modelo="fabricante" selecionado={dados.fabricantesSelecionados} onChange={(v, x) => checkedList("fabricantesSelecionados", v, x)} />

                <ListCheckBox title="Grupos" modelo="grupo" selecionado={dados.gruposSelecionados} onChange={(v, x) => checkedList("gruposSelecionados", v, x)} />
              </div>
            )}
          </>
        )}
      </LoadingContainerPadrao>
    </ModalPadrao>
  );
}
